module.exports = __webpack_public_path__ + "static/media/home-b.f29cf2e1.svg";